// extracted by mini-css-extract-plugin
export var deliveryRow = "_r1-a";
export var fixedHeight = "_r1-4";
export var freightLogo = "_r1-9";
export var fullWidth = "_r1-3";
export var priceColumn = "_r1-5";
export var radioSelected = "_r1-7";
export var radioUnselected = "_r1-6";
export var selectedOption = "_r1-2";
export var selectedOptionContainer = "_r1-1";
export var selection = "_r1-0";
export var tallSkeletonText = "_r1-8";